module.exports = __webpack_public_path__ + "img/stock.3716c380.png";